module.exports = __webpack_public_path__ + "img/h1.e261d76d.png";